export default "__VITE_PUBLIC_ASSET__615fbe38__"